import React from 'react';
import { Col, Row, Card, Progress } from 'antd';
import { withTranslation } from 'react-i18next';

class BatteryInformationCard extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { t } = this.props;
    return (
      <Card
        title={<h2 style={{ marginLeft: '45%' }}>{t('label_battery')}</h2>}
        bordered={true}
      >
        <Row style={{ marginLeft: '50px' }}>
          <Col span={8}>
            <Card style={{ width: 200, height: 200 }}>
              <h3 style={{ marginLeft: 50 }}>{t('label_health')}</h3>
              <br />
              <br />
              <h4 style={{ marginLeft: 15, fontSize: 18 }}>
                {this.props.health}
              </h4>
            </Card>
          </Col>
          <Col span={8}>
            <Card style={{ width: 200, height: 200 }}>
              <h3 style={{ marginLeft: '20%' }}>{t('label_temperature')}</h3>
              <br />
              <br />
              <h4 style={{ marginLeft: '45%', fontSize: 18 }}>
                {this.props.temperature}&deg;C
              </h4>
            </Card>
          </Col>
          <Col span={8}>
            <Card style={{ width: 200, height: 200 }}>
              <h3 style={{ marginLeft: 60 }}>{t('label_level')}</h3>
              <Progress
                strokeLinecap="square"
                type="dashboard"
                percent={parseInt(this.props.level, 10)}
                style={{ marginLeft: 20 }}
              />
              {parseInt(this.props.level, 10) == 100 ? (
                <h4 style={{ marginLeft: 60, fontSize: 15 }}>
                  {this.props.level}%
                </h4>
              ) : null}
            </Card>
          </Col>
        </Row>
      </Card>
    );
  }
}

export default withTranslation()(BatteryInformationCard);
